import React, { useState } from 'react'
import { Button, Card, CardContent, Menu, TextField } from '@material-ui/core'

import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import StopIcon from '@material-ui/icons/Stop'
import AddIcon from '@material-ui/icons/Add'
import PublishIcon from '@material-ui/icons/Publish'
import GetAppIcon from '@material-ui/icons/GetApp'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import MenuButton from '../MenuButton'

import basicDemo from './demos/Basic demo.json'
import psytranceDemo from './demos/Psytrance demo.json'

const demos = [basicDemo, psytranceDemo]

const MainControls = (props: {
	projectName: string,
	onProjectNameChange: (projectName: string) => void,
	onAddChannel: () => void,
	onPlay: () => void,
	onPause: () => void,
	onStop: () => void,
	onLoadDemo: (demo: any) => void,
	isPlaying: boolean,
	onExportProject: () => void,
	onImportProject: () => void,
}) => {
	const {
		projectName,
		onProjectNameChange,
		onAddChannel,
		onPlay,
		onPause,
		isPlaying,
		onStop,
		onLoadDemo,
		onExportProject,
		onImportProject,
	} = props

	const [loadDemoAnchorEl, setLoadDemoAnchorEl] = useState<null | HTMLElement>(null)
	
	return (
		<Card id="main-control" style={{ margin: 24, display: 'flex', alignItems: 'flex-end'  }}>
			<CardContent style={{ flexGrow: 1, display: 'flex', alignItems: 'flex-end' }}>
				<TextField
					style={{ marginRight: 12 }}
					value={projectName}
					label='Project name'
					variant='filled'
					onChange={(e: any) => onProjectNameChange(e.target.value)}
				/>

				<Button
					// color='primary'
					startIcon={<PlayArrowIcon />}
					onClick={onPlay}
					disabled={isPlaying}
				>
					Play
				</Button>

				{/* <Button
					variant='contained'
					// color='primary'
					startIcon={<AddIcon />}
					onClick={onPause}
					disabled={!isPlaying}
				>
					Pause
				</Button> */}

				<Button
					// color='primary'
					startIcon={<StopIcon />}
					onClick={onStop}
					disabled={!isPlaying}
				>
					Stop
				</Button>
				
				<Button
					// color='primary'
					startIcon={<AddIcon />}
					onClick={onAddChannel}
				>
					Add channel
				</Button>
				
				<div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>

					<MenuButton
						buttonEl={
							<Button
								// color='primary'
								startIcon={<CloudDownloadIcon />}
							>
								Load demo
							</Button>
						}
						onItemClick={onLoadDemo}
						items={demos}
						getItemName={(demo: any) => demo.name}
					/>

					{/* <Button
						// color='primary'
						startIcon={<CloudDownloadIcon />}
						onClick={(e: any) => setLoadDemoAnchorEl(e.currentTarget)}
					>
						Load demo
					</Button>

					<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
						{({ TransitionProps, placement }) => (
							<Grow
								{...TransitionProps}
								style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
							>
								<Paper>
									<ClickAwayListener onClickAway={handleClose}>
										<MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
												{demos.map((demo: any) => <MenuItem onClick={() => { setLoadDemoAnchorEl(null); onLoadDemo(demo) }}>{demo.name}</MenuItem>)}
										</MenuList>
									</ClickAwayListener>
								</Paper>
							</Grow>
						)}
					</Popper> */}

					<Menu
						anchorEl={loadDemoAnchorEl}
						keepMounted
						open={Boolean(loadDemoAnchorEl)}
						onClose={() => setLoadDemoAnchorEl(null)}
					>
					</Menu>
					
					<Button
						// color='primary'
						startIcon={<PublishIcon />}
						onClick={onExportProject}
					>
						Export
					</Button>
					
					<Button
						// color='primary'
						startIcon={<GetAppIcon />}
						onClick={onImportProject}
					>
						Import
					</Button>
					
				</div>
			</CardContent>
		</Card>
	)
}

export default MainControls
